<template>
  <v-container class="mt-2">
    <v-row>
      <v-col>
    <Headlines />
    <Releases />
    <Newsletter />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src
import Headlines from '@/components/Headlines.vue'
import Releases from '@/components/Releases.vue'
import Newsletter from '@/components/Newsletter.vue'

export default {
  name: 'Home',
  components: {
    Headlines,
    Releases,
    Newsletter,
  }
}
</script>
